import { useTranslate } from '@ur-solutions/react-hooks'
import { Module } from '@/modules/companies/consts'
import React from 'react'
import { isMobileOnly } from 'react-device-detect'
import styled from 'styled-components'
import { useModuleConfig } from '@/utils/hooks'
import {
  InfoBox,
  OldSection,
  SectionHeader,
  SettingsWrapper,
} from '../components'
import { ModuleOptionCards } from '../components/ModuleOptionCards'

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

interface TimeEntrySettingsProps {}

export const TimeEntrySettings: React.FC<TimeEntrySettingsProps> = () => {
  const translations = useTranslate({
    info1: 'settings.info.time-entries-1',

    moduleOptions: 'settings.module-options',

    prompt: {
      delete: ['settings.prompts.delete-time-entry-project', { name: '' }],
      deleteTitle: 'settings.prompts.time-entry-project-delete-title',
    },
  })

  const { moduleConfig } = useModuleConfig(Module.TIMESHEETS)

  return (
    <SettingsWrapper grid={{ flow: 'row' }}>
      <InfoBox initCollapsed={isMobileOnly}>
        <p>{translations.info1}</p>
      </InfoBox>

      <OldSection>
        <Header>
          <SectionHeader>{translations.moduleOptions}</SectionHeader>
        </Header>

        {!!moduleConfig && <ModuleOptionCards module={Module.TIMESHEETS} />}
      </OldSection>
    </SettingsWrapper>
  )
}
